"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

require("./oldBrowsers.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OldBrowsers = function (_Component) {
  (0, _inherits3.default)(OldBrowsers, _Component);

  function OldBrowsers(props) {
    (0, _classCallCheck3.default)(this, OldBrowsers);

    var _this = (0, _possibleConstructorReturn3.default)(this, (OldBrowsers.__proto__ || (0, _getPrototypeOf2.default)(OldBrowsers)).call(this, props));

    _this.detectIE = function () {
      var userAgent = window.navigator.userAgent;
      var msie = userAgent.indexOf("MSIE ");
      if (msie > 0) {
        _this.setState({
          usingIE: true
        });
      }

      var trident = userAgent.indexOf("Trident/");

      if (trident > 0) {
        _this.setState({
          usingIE: true
        });
      }

      var edge = userAgent.indexOf("Edge/");
      if (edge > 0) {
        _this.setState({
          usingEdge: true
        });
      }
    };

    _this.closeDetectIE = function () {
      _this.setState({
        closeDetectIE: true
      });
    };

    _this.state = {
      usingIE: false,
      usingEdge: false,
      closeDetectIE: false
    };
    return _this;
  }

  (0, _createClass3.default)(OldBrowsers, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf("safari") != -1) {
        if (ua.indexOf("chrome") > -1) {
          document.querySelector("body").classList.add("chrome");
        } else {
          document.querySelector("body").classList.add("safari");
        }
      }
      this.detectIE();
    }
  }, {
    key: "render",
    value: function render() {
      var detectIE = (0, _classnames2.default)({
        detectIE: true,
        close: this.state.closeDetectIE
      });

      var messageIEDetect = null;
      if (this.state.usingIE) {
        messageIEDetect = _react2.default.createElement(
          "div",
          { className: detectIE },
          _react2.default.createElement("span", {
            className: "icon-close",
            onClick: this.closeDetectIE,
            role: "button",
            tabIndex: "-1"
          }),
          _react2.default.createElement(
            "p",
            null,
            "Hemos detectado que est\xE1s usando ",
            _react2.default.createElement(
              "strong",
              null,
              "Internet Explorer"
            ),
            ". Esta web est\xE1 optimizada para Chrome, Firefox, Safari y Microsoft Edge."
          )
        );
      }
      return _react2.default.createElement(
        "div",
        null,
        messageIEDetect
      );
    }
  }]);
  return OldBrowsers;
}(_react.Component);

exports.default = OldBrowsers;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OldBrowsers/OldBrowsers.jsx
// module id = 707
// module chunks = 0